import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propStr } from '../../../../../../../../../helpers/custom-prop-types';
import TagIcon from '../../../../../../../../Icon/Svg/TagIcon';
/**
 * Prpffit Searchの人気タグが存在しない場合に表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ProfessionalMyPageTopProffitSearchSlideTagsContentEmpty = (props) => {
    const { className } = props;
    return (_jsxs("div", Object.assign({ className: clsx('professional_mypage_top_proffit_search_slide_tags_empty', className) }, { children: [_jsx("div", Object.assign({ className: 'empty_icon' }, { children: _jsx(TagIcon, { className: 'icon_svg gray' }) })), _jsx("div", Object.assign({ className: 'empty_text' }, { children: "\u307E\u3060\u30BF\u30B0\u306F\u3042\u308A\u307E\u305B\u3093" }))] })));
};
ProfessionalMyPageTopProffitSearchSlideTagsContentEmpty.propTypes = {
    className: propStr(),
};
ProfessionalMyPageTopProffitSearchSlideTagsContentEmpty.defaultProps = {
    className: '',
};
export default ProfessionalMyPageTopProffitSearchSlideTagsContentEmpty;
